export { isPlainObject, deepMerge } from './deepMerge';